import React from 'react'
import PropTypes from 'prop-types'
import {
    Flex,
    Copy,
    getLocalizedSrc,
    useConfig,
    themeColor,
    themeFontSize,
    themeFontWeight,
} from '@elparking/components'

import styled from 'styled-components'

import { FormattedMessage } from 'react-intl'

const EventsBannerContainer = styled(Flex)`
    background-image: url('${(props) => getLocalizedSrc('/images/events/bg-banner-eventos.svg', props.country, props.flavor, props.excludedFlavors)}');
    background-size: cover;
    background-position: center;
`

const EventsBannerLink = styled.a`
    font-size: ${themeFontSize('xxSmall')};
    font-weight: ${themeFontWeight('book')};
    color: ${themeColor('gray')};
`

const TextEventsBanner = styled(Copy)`
    line-height: 1.4em;
    font-weight: ${themeFontWeight('book')};
`

export const EventsBannerLinkContainer = styled(Flex)`
    height: 32px;
    cursor: pointer;
`
function EventsBanner ({ link }) {
    const country = useConfig('country')
    const flavor = useConfig('flavor')
    const excludedFlavors = useConfig('excludedFlavors')
    return (
        <EventsBannerContainer px={['8px', '10px']} py={'8px'} alignItems='center' country={country} flavor={flavor} excludedFlavors={excludedFlavors}>
            <TextEventsBanner lineHeight='xxSmall' fontWeight='medium' padding={'0'} size='xxSmall'>
                <FormattedMessage defaultMessage='Consulta el listado de eventos, te daremos la disponibilidad y el precio de los parkings cercanos' />
            </TextEventsBanner>
            <EventsBannerLinkContainer bg='accent' w={['56%', '32%']} justifyContent='center' alignItems='center' ml={['8px', '4px']} p={'8px'}>
                <EventsBannerLink href={link}>
                    <FormattedMessage defaultMessage='Ver eventos' />
                </EventsBannerLink>
            </EventsBannerLinkContainer>
        </EventsBannerContainer>
    )
}

EventsBanner.propTypes = {
    link: PropTypes.string,
}

export default EventsBanner
